module.exports = __webpack_public_path__ + "static/media/amiloidosis.e40cc8bb.png";